import { render, staticRenderFns } from "./PigRunManager.vue?vue&type=template&id=3f59ce26"
import script from "./PigRunManager.vue?vue&type=script&lang=ts"
export * from "./PigRunManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports